var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMastercard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.407,
    height: 108,
    viewBox: "0 0 152.407 108"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h152.407v108H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5f00",
    d: "M60.412 25.697h31.5v56.606h-31.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.412 54a35.938 35.938 0 0113.75-28.303 36 36 0 100 56.606A35.938 35.938 0 0162.412 54z",
    fill: "#eb001b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.407 54a35.999 35.999 0 01-58.245 28.303 36.005 36.005 0 000-56.606A35.999 35.999 0 01134.407 54zM130.972 76.308v-1.16h.468v-.235h-1.19v.236h.467v1.159zm2.31 0V74.91h-.364l-.42.962-.42-.962h-.364v1.398h.257v-1.054l.394.908h.267l.394-.91v1.056z",
    fill: "#f79e1b"
  })));
}

export default "/images/mastercard.svg?85aa71c675da491f53562e523cf752dc";
export { SvgMastercard as ReactComponent };